import React from "react";
import parse from "html-react-parser";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import MaterialTable from "material-table";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  rowHeight: {
    maxHeight: "7.5em",
    overflow: "hidden",
    "& p": {
      lineHeight: "1.5em",
    },
  },
});

export default function TableDetail({ data, onCrudTK }: any) {
  const classes = useStyles();

  return (
    <>
      <Button
        onClick={() =>
          onCrudTK({
            action: "Add",
            title: data.title_id,
            data: { id_type: data.id, imagesRead: [], images: [] },
          })
        }
        variant="contained"
        size="small"
        startIcon={<Add />}
      >
        Add {data.title_id}
      </Button>
      <MaterialTable
        columns={[
          { title: "No.", field: "no" },
          { title: "Title ID", field: "title_id" },
          { title: "Title EN", field: "title_en" },
          {
            title: "Content ID",
            field: "content_id",
            render: (rowData) => (
              <div className={classes.rowHeight}>
                {parse(rowData.content_id)}
              </div>
            ),
          },
          {
            title: "Content EN",
            field: "content_en",
            render: (rowData) => (
              <div className={classes.rowHeight}>
                {parse(rowData.content_en)}
              </div>
            ),
          },
          {
            title: "Images",
            field: "images",
            render: (rowData) => {
              const images = JSON.parse(rowData.images);
              if (images.length) {
                return (
                  <div style={{ display: "flex", gap: 8 }}>
                    {images.map((image: string) => (
                      <img
                        src={`${process.env.REACT_APP_URL}/images/${image}`}
                        alt={image}
                        style={{ width: 50, objectFit: "cover" }}
                      />
                    ))}
                  </div>
                );
              }
              return <p>-</p>;
            },
          },
        ]}
        data={() =>
          new Promise((resolve) => {
            fetch(
              `${process.env.REACT_APP_URL}/api/jlp/content/tk/${data.id}`
            ).then(async (result: any) => {
              const resJson = await result.json();
              resolve({
                data: resJson.data,
                page: 0,
                totalCount: resJson.data.length,
              });
            });
          })
        }
        options={{
          paging: false,
          sorting: false,
          search: false,
          showTitle: false,
          toolbar: false,
        }}
        style={{ boxShadow: "none", marginTop: 8, marginBottom: 32 }}
        onRowClick={(event, rowData: any) => {
          const parseImages = JSON.parse(rowData.images);
          onCrudTK({
            action: "Edit",
            title: rowData.title_id,
            data: {
              id: rowData.id,
              id_type: rowData.id_type,
              titleId: rowData.title_id,
              titleEn: rowData.title_en,
              contentId: rowData.content_id,
              contentEn: rowData.content_en,
              oldImages: parseImages,
              images: [],
              no: rowData.no,
              imagesRead: parseImages.map(
                (image: string) =>
                  `${process.env.REACT_APP_URL}/images/${image}`
              ),
            },
          });
        }}
      />
    </>
  );
}
